import { createFileRoute, redirect } from "@tanstack/react-router";
import { m } from "~/lib/i18n";

export interface CreatePortfolioRouteSearch {
  readonly prompt?: string;
  readonly threadId?: string;
}

function readSearchString(value: unknown): string | undefined {
  return typeof value === "string" && value.trim().length > 0
    ? value.trim()
    : undefined;
}

function createPortfolioThreadId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }

  return `portfolio-${Date.now().toString(36)}`;
}

export const Route = createFileRoute("/_app/create-portfolio")({
  beforeLoad: ({ search }) => {
    const normalizedSearch = search as CreatePortfolioRouteSearch;
    // Default creation path is the direct index builder (M7). An explicit
    // prompt keeps the AI construction workspace behavior.
    if (!normalizedSearch.prompt) {
      throw redirect({ to: "/build" });
    }
    throw redirect({
      search: {
        portfolioConstructionPrompt: normalizedSearch.prompt,
        portfolioConstructionThreadId:
          normalizedSearch.threadId ?? createPortfolioThreadId(),
      },
      to: "/agents",
    });
  },
  head: () => ({
    meta: [
      { title: m.create_portfolio_page_meta_title() },
      {
        content: m.create_portfolio_page_meta_description(),
        name: "description",
      },
    ],
  }),
  validateSearch: (raw): CreatePortfolioRouteSearch => {
    const record =
      raw && typeof raw === "object" && !Array.isArray(raw)
        ? (raw as Record<string, unknown>)
        : {};
    return {
      prompt: readSearchString(record.prompt),
      threadId: readSearchString(record.threadId),
    };
  },
});
